import React from 'react';
import DragHandle from '../dragHandle.svg.js';
import _Symbol from '../symbol';
import Tooltip from '../tooltip';
import { dataHooks } from './constants.js';
export default (function (props) {
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHooks.itemRow,
    className: props.getClassName('sbdl-item-row-base') + (props.dragHandle ? ' has-drag-handle' : '') + (props.dragHandleEnabled ? '' : ' disabled-drag-handle'),
    "data-is-default": props.isDefault ? 'true' : 'false'
  }, props.dragHandleTooltipContent && props.dragHandle ? /*#__PURE__*/React.createElement("div", {
    key: "itemRowDragHandle",
    className: "drag-handle-container"
  }, /*#__PURE__*/React.createElement(_Symbol, {
    className: "symbol-dragHandle"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    className: "dragHandle-tooltip",
    content: props.dragHandleTooltipContent,
    shouldTranslate: false,
    isOpen: props.isDragging
  }, /*#__PURE__*/React.createElement(DragHandle, null)))) : null, props.dragHandle && !props.dragHandleTooltipContent ? /*#__PURE__*/React.createElement("div", {
    key: "itemRowDragHandle",
    className: "drag-handle-container"
  }, /*#__PURE__*/React.createElement(_Symbol, {
    className: "symbol-dragHandle"
  }, /*#__PURE__*/React.createElement(DragHandle, null))) : null, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, props.children));
});